<template>
  <div class="p-categories-admin">
    <template slot="header">
      <!-- <filter-bar :showSort="true"></filter-bar> -->
    </template>
    <page-title>{{ docType.singular | capitalize }} Categories</page-title>

    <section-block>
      <template slot="actions" v-if="$route.meta.isAdmin">
        <base-button
          :primary="true"
          @click="$router.push({ name: 'CategoryCreate' })"
          >Create Category</base-button
        >
      </template>

      <vuetable
        class="c-data-table"
        :api-mode="false"
        :fields="table.fields"
        :data="categories"
        @vuetable:row-clicked="onRowClicked"
      >
        <template slot="date-created" slot-scope="props">
          <base-datetime :date="props.rowData.created_time"></base-datetime>
        </template>
      </vuetable>
    </section-block>
  </div>
</template>

<script>
import Vue from 'vue';

// import FilterBar from "@/components/FilterBar";
import CategoryActions from '@/components/CategoryActions';

Vue.component('category-actions', CategoryActions);

export default {
  name: 'categories-admin',

  data() {
    return {
      loading: false,
      table: {
        fields: [
          {
            name: 'name',
            titleClass: 'u-ta-left',
            title: 'Category Name',
            width: '20%',
          },
          {
            name: 'description',
            titleClass: 'u-ta-left',
            title: 'Category description',
            width: '40%',
          },
          {
            name: 'date-created',
            titleClass: 'u-ta-left',
            title: 'Date Created',
            width: '20%',
          },
          {
            name: CategoryActions,
            title: 'Actions',
            titleClass: 'u-ta-center u-hide-mobile',
            dataClass: 'u-ta-center u-hide-mobile',
            width: '10%',
          },
        ],
      },
    };
  },

  created() {
    const { docType } = this.$route.params;
    this.$store.dispatch('documents/init', { docType });
    this.$store.dispatch('categories/list');
  },

  methods: {
    onRowClicked(dataItem, event) {
      if (dataItem.event.target.localName === 'td' || dataItem.event.target.parentNode.localName === 'td') {
        this.$router.push({
          name: 'CategoryEdit',
          params: { categoryId: dataItem.data.id },
        });
      }
    },
  },

  computed: {
    docType() {
      return this.$store.state.documents.docType;
    },

    categories() {
      return this.$store.state.categories.categories;
    },
  },
};
</script>
